(function () {

    'use strict';

    angular.module('Services').factory('SharedCarrierTableService', SharedCarrierTableService);

    SharedCarrierTableService.$inject = ['Carrier', 'TableLiteFactory', '$location'];

    function SharedCarrierTableService(Carrier, TableLiteFactory, $location) {
        return function (carriers, bridge) {
            var tableStructure = {
                tableName: 'CarrierProfilesTable',
                config: {
                    noPagination: false,
                    noHeaders: false,
                    noTopOptions: false,
                    noFooter: false,
                    rowsUnclickable: false
                },
                headers: [{
                    label: 'PROFILE NAME',
                    viewName: 'name',
                    filterName: 'name',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                },{
                    label: "CARRIER",
                    viewName: "carrierLogo",
                    filterName: "carrierId",
                    filter: {
                        type: "select2",
                        placeholder: "Search",
                        filterBy : 'id',
                        items: carriers,
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'EMAIL',
                    viewName: 'email',
                    filterName: 'email',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'PHONE',
                    viewName: 'phone',
                    filterName: 'phone1',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'WEBSITE',
                    viewName: 'website',
                    filterName: 'website',
                    filter: {
                        type: 'text',
                        placeholder: 'Search',
                        onSubmit: function (header) {
                            sendRequest(evaluateFilter(header));
                        },
                        model: ''
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }, {
                    label: 'Status',
                    viewName: 'status',
                    filterName: 'active',
                    filter: {
                        type: 'select2',
                        placeholder: 'Select One',
                        items: ['Active', 'Inactive'],
                        onSelect: function (header) {
                            var filter = {};

                            if (header.filter.model == 'Active') {
                                filter[header.filterName] = true;
                            } else {
                                filter[header.filterName] = false;
                            }

                            sendRequest(filter);
                        }
                    },
                    headerFn: function () {
                        sort(this.filterName);
                    }
                }],
                data: [],
                rowOnClick: function (item) {
                    bridge.viewProfile(item)
                }
            };
            const tableActions = new TableLiteFactory(tableStructure,
                {
                    serviceCallback: Carrier.getExternalCarrierProfiles,
                    callbackFormat: ['success','error','filter'],
                    postRequestCallback: data => {
                        buildTableData(data);
                    },
                    postRequestErrorCallback: err => {
                        buildTableData(null);
                        toastr.error(err);
                    },
                    defaultFilters : {
                        size: 10,
                        page: 0,
                        sort: 'id,desc',
                        enabled: true
                    }
                }
            );
            const sort = tableActions.sort;
            const evaluateFilter = tableActions.evaluateFilter;
            const sendRequest = tableActions.sendRequest;

            function buildTableData(data) {
                /*** START - Building of Data ***/
                tableActions.initializeTableData(data);
                angular.forEach(data.content, function (row, index) {
                    if (row.phone1 && row.phone2) {
                        row.phone = {
                            type: 'multiLine',
                            list: [row.phone1, row.phone2]
                        };
                    } else {
                        row.phone = row.phone1 || row.phone2 || 'N/A';
                    }
                    row.status = {
                        type: 'status',
                        status: row.active,
                        label: row.active ? 'Active' : 'Inactive'
                    };
                    row.email = row.email || 'N/A';
                    row.website = row.website || 'N/A';
                    row.carrierLogo = {
                        imgSrc: angular.getObjVal(row,'carrier.logoUrl'),
                        type: 'logotype'
                    };
                    tableStructure.data.push(row);
                });
            };
            this.tableData = tableStructure;
        };
    };
})();



// WEBPACK FOOTER //
// ./js/services/tables/SharedCarrierTableService.js